export const gitVersion = 'main-1.0.13-526-gfd96bd05';
